import { HTML_TAG_REGEX } from '@abg/shared/regex';

export function isHtml(content: string): boolean {
  return HTML_TAG_REGEX.test(content);
}
